<template>
    <group-type-table template-type="employee"></group-type-table>
</template>

<script>
    const groupTypeTable =() => import ('@/components/orgApps/GroupType/GroupTypeTable');

    export default {
        name: "dashboard",
        components: {
            groupTypeTable
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>